module.exports = __webpack_public_path__ + "static/phone_bg-12da7aca1ae6e5d243dc24434a2accd3.png";